"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.verifyToken = exports.authorise = exports.refreshToken = void 0;
var client_1 = require("@apollo/client");
var apolloClient_1 = require("./apolloClient");
var apolloClient = (0, apolloClient_1.initializeApollo)();
var refreshToken = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var refreshTokenMutation, data, error_1;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 2, , 3]);
                refreshTokenMutation = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      mutation refreshToken($token: String!) {\n        refreshToken(refreshToken: $token) {\n          token\n          success\n          errors\n          payload\n          refreshToken\n        }\n      }\n    "], ["\n      mutation refreshToken($token: String!) {\n        refreshToken(refreshToken: $token) {\n          token\n          success\n          errors\n          payload\n          refreshToken\n        }\n      }\n    "])));
                return [4 /*yield*/, apolloClient.mutate({
                        mutation: refreshTokenMutation,
                        variables: {
                            token: token.refreshToken
                        }
                    })];
            case 1:
                data = (_d.sent()).data;
                token.token = data.refreshToken.token;
                token.refreshToken = (_a = data.refreshToken.refreshToken) !== null && _a !== void 0 ? _a : token.refreshToken; // Fall back to old refresh token
                token.exp = (_c = (_b = data.refreshToken.payload) === null || _b === void 0 ? void 0 : _b.exp) !== null && _c !== void 0 ? _c : token.exp; // Fall back to old expiry
                return [2 /*return*/, token];
            case 2:
                error_1 = _d.sent();
                console.log(error_1);
                return [2 /*return*/, __assign(__assign({}, token), { errors: "RefreshTokenError" })];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.refreshToken = refreshToken;
var authorise = function (email, password, authMutation) { return __awaiter(void 0, void 0, void 0, function () {
    var data, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                authMutation =
                    authMutation !== null && authMutation !== void 0 ? authMutation : (0, client_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      mutation tokenAuth($email: String!, $password: String!) {\n        tokenAuth(email: $email, password: $password) {\n          success\n          token\n          errors\n          refreshToken\n          user {\n            firstName\n            lastName\n            email\n          }\n        }\n      }\n    "], ["\n      mutation tokenAuth($email: String!, $password: String!) {\n        tokenAuth(email: $email, password: $password) {\n          success\n          token\n          errors\n          refreshToken\n          user {\n            firstName\n            lastName\n            email\n          }\n        }\n      }\n    "])));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, apolloClient.mutate({
                        mutation: authMutation,
                        variables: {
                            email: email,
                            password: password
                        }
                    })];
            case 2:
                data = (_a.sent()).data;
                if (!data.tokenAuth.success) {
                    return [2 /*return*/, {
                            errors: data.tokenAuth.errors
                        }];
                }
                return [2 /*return*/, __assign(__assign({}, data.tokenAuth.user), { accessToken: data.tokenAuth.token, refreshToken: data.tokenAuth.refreshToken })];
            case 3:
                error_2 = _a.sent();
                console.log(error_2);
                return [2 /*return*/, {
                        errors: "TokenAuthError"
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.authorise = authorise;
var verifyToken = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var verifyTokenMutation, data, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                verifyTokenMutation = (0, client_1.gql)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      mutation verifyToken($token: String!) {\n        verifyToken(token: $token) {\n          success\n          errors\n          payload\n        }\n      }\n    "], ["\n      mutation verifyToken($token: String!) {\n        verifyToken(token: $token) {\n          success\n          errors\n          payload\n        }\n      }\n    "])));
                return [4 /*yield*/, apolloClient.mutate({
                        mutation: verifyTokenMutation,
                        variables: {
                            token: token.accessToken
                        }
                    })];
            case 1:
                data = (_a.sent()).data;
                if (!data.verifyToken.success) {
                    return [2 /*return*/, __assign(__assign({}, token), { errors: data.verifyToken.errors })];
                }
                token.tokenExp = data.verifyToken.payload.exp;
                return [2 /*return*/, token];
            case 2:
                error_3 = _a.sent();
                console.error(error_3);
                return [2 /*return*/, __assign(__assign({}, token), { errors: "VerifyTokenError" })];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.verifyToken = verifyToken;
var templateObject_1, templateObject_2, templateObject_3;
